import React from "react";
import { useTranslation } from "react-i18next";
import { Box, useTheme } from "@mui/material";
import Modal from "../modal";
import Button from "../button";
import Typography from "../typography";

export interface ConfirmDialogProps {
  title: string;
  body: React.ReactNode;
  confirmLabel: string;
  // Destructive actions confirm in red.
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  body,
  confirmLabel,
  destructive = false,
  loading = false,
  onConfirm,
  onClose,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose}>
      <Box sx={{ width: { xs: "min(320px, 100vw - 64px)", sm: 400 } }}>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", marginBottom: 12 }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          style={{ color: theme.palette.text.secondary }}
        >
          {body}
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
          <Button variant="text" onClick={onClose} disabled={loading}>
            {t("ui.cancel")}
          </Button>
          <Button
            color={destructive ? "error" : "primary"}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmDialog;
